import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Button from 'react-bootstrap/Button';

import { Scrollbars } from 'react-custom-scrollbars';
import { Input, Descriptions, Dropdown, Menu, Select, Tooltip } from 'antd';
import { isEmpty } from '../../util/isEmpty';
import CustomDropdownRender from '../common/CustomDropdownRender';
import { sortArrObjStr } from '../../util/sortArrObjStr';
const { SubMenu } = Menu;
const { Option } = Select;

const ADDRESS = 'address';
const CITY = 'city';
const COUNTRY = 'country';
const POSTAL = 'postal';
const NAME = 'name';
const EMAIL = 'email';
const PORT = 'port';

const CONTACT_NAME = 'contact_name';
const PHONE_NUMBER = 'phone_number';

const BUSINESS_TYPE = 'busines_type';
const locationType = [
  { key: 'warehouse', title: 'Warehouse' },
  { key: 'businesswithliftgate', title: 'Business with Lift Gate' },
  { key: 'businesswithloadingdock', title: 'Business with Loading Dock' },
  { key: 'residential', title: 'Residential' },
  { key: 'port', title: 'Port' },
];

/**
 * @component
 * @category Form Page
 * @name NewFactoryDescForm
 * @description New factory description form on pickup/delivery section
 * <br> <br>
 * **Example**
 * ```js
 *
 *<NewFactoryDescForm isPickupMode={true} portsJSON={{}} myCountries={[]} handleNewFactoryInfoChange={() => {}} handleSelectExistingNewPort={() => {}} newFactoryInfo={{}} />
 * ```
 */
class NewFactoryDescForm extends Component {
  render() {
    const {
      portsJSON,
      myCountries,
      handleSelectExistingNewPort,

      newFactoryInfo,
      handleNewFactoryInfoChange,

      isPickupMode,
    } = this.props;

    // let tempCountryArr = newFactoryInfo.country
    //   ? [newFactoryInfo.country]
    //   : myCountries;

    let tempCountryArr = newFactoryInfo.country ? [newFactoryInfo.country] : [];

    // console.log('tempCountryArr', tempCountryArr);
    // tempCountryArr = []; //delete this line, it was for test

    //port menu
    // const menu = (
    //   <div>
    //     <Scrollbars autoHeight={true} autoHeightMin={0}>
    //       <Menu
    //         onClick={handleSelectExistingNewPort}
    //         style={{ border: '1px solid #bbc' }}
    //       >
    //         {tempCountryArr.map((country1, index) => (
    //           <SubMenu
    //             title={country1}
    //             key={index}
    //             popupClassName="my-form-factory-menu-submenu"
    //           >
    //             {Array.isArray(portsJSON.Ports) &&
    //               portsJSON.Ports.map(
    //                 (port) =>
    //                   port.Country === country1 && (
    //                     <Menu.Item
    //                       key={JSON.stringify({
    //                         id: port.id,
    //                         name: port.Name,
    //                         country: port.Country,
    //                       })}
    //                     >
    //                       {port.Name}
    //                     </Menu.Item>
    //                   )
    //               )}
    //           </SubMenu>
    //         ))}
    //       </Menu>
    //     </Scrollbars>
    //   </div>
    // );

    //no. of items in a row depending upon screen size
    const descColumn = { xxl: 2, xl: 2, lg: 2, md: 2, sm: 1, xs: 1 };
    return (
      <>
        <Descriptions
          style={{
            marginTop: '15px',
          }}
          bordered={true}
          size="small"
          // layout="vertical"
          column={descColumn}
        >
          <Descriptions.Item label="Country">
            <Select
              value={newFactoryInfo.country || undefined}
              style={{
                width: '100%',
                maxWidth: window.innerWidth >= 768 && '147px',
                border: !newFactoryInfo.country && '1px solid red',
                borderRadius: !newFactoryInfo.country && '4px',
              }}
              placeholder="Select country"
              onChange={(value) => {
                handleNewFactoryInfoChange(COUNTRY, value);
                // console.log('select country val:', value);
              }}
              dropdownRender={(menu) => (
                <div>
                  {myCountries.length !== 0 ? (
                    menu
                  ) : (
                    <CustomDropdownRender showSpin={true} />
                  )}
                </div>
              )}
            >
              {Array.isArray(myCountries) &&
                sortArrObjStr(myCountries).map((country) => (
                  <Option key={country} value={country}>
                    {country}
                  </Option>
                ))}
            </Select>
          </Descriptions.Item>

          <Descriptions.Item label={isPickupMode ? 'Port' : 'Destination city'}>
            <Select
              value={
                (newFactoryInfo.port.name || newFactoryInfo.port.country) &&
                `${newFactoryInfo.port.name}, ${newFactoryInfo.port.country}`
              }
              style={{
                width: '100%',
                maxWidth: window.innerWidth >= 768 && '147px',
                borderRadius: isEmpty(newFactoryInfo.port) && '4px',
                border: isEmpty(newFactoryInfo.port) && '1px solid red',
              }}
              placeholder="Select port"
              onChange={(portObjStr) => {
                handleSelectExistingNewPort(portObjStr);
                // console.log('new select portObjStr:', portObjStr);
              }}
              dropdownRender={(menu) => (
                <div>
                  {tempCountryArr.length !== 0 ? (
                    menu
                  ) : (
                    <CustomDropdownRender text="select country first" />
                  )}
                </div>
              )}
            >
              {Array.isArray(portsJSON.Ports) &&
                sortArrObjStr(portsJSON, 'Ports', 'Name').map(
                  (port) =>
                    port.Country === newFactoryInfo.country && (
                      <Option
                        key={port.id}
                        value={JSON.stringify({
                          id: port.id,
                          name: port.Name,
                          country: port.Country,
                        })}
                      >
                        {port.Name}
                      </Option>
                    )
                )}
            </Select>

            {/* <Dropdown
              overlay={
                tempCountryArr.length === 0 ? (
                  <Menu>
                    <CustomDropdownRender text="select country first" />
                  </Menu>
                ) : (
                  menu
                )
              }
            >
              <span onClick={(e) => e.preventDefault()}>
                <Input
                  placeholder="Select port"
                  value={
                    (newFactoryInfo.port.name || newFactoryInfo.port.country) &&
                    `${newFactoryInfo.port.name}, ${newFactoryInfo.port.country}`
                  }
                  style={{
                    border: isEmpty(newFactoryInfo.port) && '1px solid red',
                  }}
                />
              </span>
            </Dropdown> */}
          </Descriptions.Item>

          <Descriptions.Item label="City">
            <Input
              placeholder="Enter city"
              value={newFactoryInfo.city}
              onChange={(e) => handleNewFactoryInfoChange(CITY, e.target.value)}
              style={{
                border: !newFactoryInfo.city && '1px solid red',
              }}
            />
          </Descriptions.Item>

          <Descriptions.Item label="Postal">
            <Input
              placeholder="Enter postal"
              value={newFactoryInfo.postal}
              onChange={(e) =>
                handleNewFactoryInfoChange(POSTAL, e.target.value)
              }
              style={{
                border: !newFactoryInfo.postal && '1px solid red',
              }}
            />
          </Descriptions.Item>

          <Descriptions.Item label="Business Name">
            <Input
              placeholder="Enter business name"
              value={newFactoryInfo.name}
              onChange={(e) => handleNewFactoryInfoChange(NAME, e.target.value)}
              style={{
                border: !newFactoryInfo.name && '1px solid red',
              }}
            />
          </Descriptions.Item>

          <Descriptions.Item label="Business Type">
            <Select
              value={newFactoryInfo[BUSINESS_TYPE] || undefined}
              style={{
                width: '100%',
                maxWidth: window.innerWidth >= 768 && '147px',
                border: !newFactoryInfo[BUSINESS_TYPE] && '1px solid red',
                borderRadius: !newFactoryInfo[BUSINESS_TYPE] && '4px',
              }}
              placeholder="Select a business type"
              onChange={(value) => {
                handleNewFactoryInfoChange(BUSINESS_TYPE, value);
                // console.log('select loc type val:', value);
              }}
            >
              {Array.isArray(locationType) &&
                sortArrObjStr(locationType, undefined, 'key').map((itemObj) => (
                  <Option key={itemObj.key} value={itemObj.key}>
                    <Tooltip title={itemObj.title}>{itemObj.title}</Tooltip>
                  </Option>
                ))}
            </Select>
          </Descriptions.Item>

          <Descriptions.Item label="Email">
            <Input
              placeholder="Enter email"
              value={newFactoryInfo.email}
              onChange={(e) =>
                handleNewFactoryInfoChange(EMAIL, e.target.value)
              }
              style={{
                border:
                  !(newFactoryInfo.email || newFactoryInfo[PHONE_NUMBER]) &&
                  '1px solid red',
              }}
            />
          </Descriptions.Item>

          <Descriptions.Item label="Contact Name">
            <Input
              placeholder="Enter contact name"
              value={newFactoryInfo[CONTACT_NAME]}
              onChange={(e) =>
                handleNewFactoryInfoChange(CONTACT_NAME, e.target.value)
              }
              style={{
                border: !newFactoryInfo[CONTACT_NAME] && '1px solid red',
              }}
            />
          </Descriptions.Item>

          <Descriptions.Item label="Phone Number">
            <Input
              placeholder="Enter phone number"
              value={newFactoryInfo[PHONE_NUMBER]}
              onChange={(e) =>
                handleNewFactoryInfoChange(PHONE_NUMBER, e.target.value)
              }
              style={{
                border:
                  !(newFactoryInfo.email || newFactoryInfo[PHONE_NUMBER]) &&
                  '1px solid red',
              }}
            />
          </Descriptions.Item>

          <Descriptions.Item label="Address">
            <Input
              placeholder="Enter address"
              value={newFactoryInfo.address}
              onChange={(e) =>
                handleNewFactoryInfoChange(ADDRESS, e.target.value)
              }
              style={{
                border: !newFactoryInfo.address && '1px solid red',
              }}
            />
          </Descriptions.Item>
        </Descriptions>

        <br>
        </br>
        <div class="container">
          <Button class="btn btn-primary" variant="success">Save</Button>
        </div>
        {/*<button> Save </button>*/}
      </>
    );
  }
}

NewFactoryDescForm.defaultProps = {
  newFactoryInfo: {},
};

NewFactoryDescForm.propTypes = {
  /**
   * whether this component is used in pickup section
   */
  isPickupMode: PropTypes.bool,
  /**
   * origin port json or destination port json on search page
   */
  portsJSON: PropTypes.object,
  /**
   * list of countries
   */
  myCountries: PropTypes.array,

  /**
   * function to update new factory info in redux store
   */
  handleNewFactoryInfoChange: PropTypes.func,
  /**
   * function to update port obj in the new factory data
   */
  handleSelectExistingNewPort: PropTypes.func,
  /**
   * pickup/delivery new factory data
   */
  newFactoryInfo: PropTypes.object,
};

export default NewFactoryDescForm;
